import React from 'react';

const FLOW_LEVELS = [
  { id: 'spotting', label: 'Spotting', emoji: '🩸' },
  { id: 'light', label: 'Light', emoji: '🩸🩸' },
  { id: 'medium', label: 'Medium', emoji: '🩸🩸🩸' },
  { id: 'heavy', label: 'Heavy', emoji: '🩸🩸🩸🩸' },
];

const SYMPTOMS = [
  'Cramps', 'Bloating', 'Fatigue', 'Mood swings',
  'Headache', 'Breakouts', 'Tender skin', 'Cravings',
];

export default function StepCycle({ data, onChange }) {
  const cycle = data.cycle || { periodDay: false, flow: null, symptoms: [] };

  const update = (partial) => onChange({ cycle: { ...cycle, ...partial } });

  const toggleSymptom = (s) => {
    const current = cycle.symptoms || [];
    update({
      symptoms: current.includes(s) ? current.filter(x => x !== s) : [...current, s],
    });
  };

  return (
    <div className="space-y-6">
      <p className="font-sans text-sm text-slate-500">Cycle data helps identify hormonal skin patterns.</p>

      {/* Period today toggle */}
      <div className="glass-card rounded-[2rem] p-5">
        <div className="flex items-center justify-between">
          <div>
            <p className="font-sans text-base font-semibold text-slate-900">Period today? 🩸</p>
            <p className="font-sans text-xs text-slate-400 mt-0.5">Tracks hormonal skin shifts</p>
          </div>
          <button
            onClick={() => update({ periodDay: !cycle.periodDay, flow: cycle.periodDay ? null : cycle.flow })}
            className={`relative w-14 h-7 rounded-full transition-all duration-300 ${cycle.periodDay ? 'bg-rose-500' : 'bg-stone-200'}`}
          >
            <span
              className={`absolute top-0.5 w-6 h-6 bg-white rounded-full shadow-sm transition-all duration-300 ${cycle.periodDay ? 'left-7.5 translate-x-0.5' : 'left-0.5'}`}
            />
          </button>
        </div>
      </div>

      {cycle.periodDay && (
        <>
          {/* Flow level */}
          <div>
            <p className="font-sans text-xs font-semibold text-slate-400 uppercase tracking-widest mb-3">
              Flow level
            </p>
            <div className="grid grid-cols-2 gap-2.5">
              {FLOW_LEVELS.map(fl => {
                const active = cycle.flow === fl.id;
                return (
                  <button
                    key={fl.id}
                    onClick={() => update({ flow: active ? null : fl.id })}
                    className={`rounded-2xl py-3.5 px-4 font-sans text-sm font-medium transition-all active:scale-95 flex items-center gap-2 ${
                      active ? 'bg-rose-500 text-white shadow-md' : 'glass-input text-slate-700'
                    }`}
                  >
                    <span className="text-xs">{fl.emoji}</span>
                    {fl.label}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Symptoms */}
          <div>
            <p className="font-sans text-xs font-semibold text-slate-400 uppercase tracking-widest mb-3">
              Symptoms today
            </p>
            <div className="flex flex-wrap gap-2.5">
              {SYMPTOMS.map(s => {
                const active = (cycle.symptoms || []).includes(s);
                return (
                  <button
                    key={s}
                    onClick={() => toggleSymptom(s)}
                    className={`rounded-full font-sans text-sm font-medium px-4 py-2.5 transition-all active:scale-95 ${
                      active ? 'bg-rose-500 text-white' : 'glass-input text-slate-700'
                    }`}
                  >
                    {s}
                  </button>
                );
              })}
            </div>
          </div>
        </>
      )}

      {!cycle.periodDay && (
        <div className="glass-card rounded-[2rem] p-6 text-center">
          <p className="text-3xl mb-2">🌸</p>
          <p className="font-sans text-sm text-slate-500">Cycle data gives you insights into how hormones affect your glow.</p>
        </div>
      )}
    </div>
  );
}
